export const AS_LEGEND = 'legend';
export const MASTER_CHECKBOX_INDEX = 0;
